var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import ClientEndpoints from "src/shared/api/client/ClientEndpoints";
import _ from "underscore";
import { reactive } from "vue";
import Client from "src/shared/store/modules/client/model/Client";
import ClientAccessTokenEndpoints from "src/shared/api/client/ClientAccessTokenEndpoints";
import Scope from "src/shared/store/client-access-token/model/Scope";
const convertToUpdateRequest = (parameters) => {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (parameters.client_type !== null && {
        client_type: parameters.client_type,
    })), (parameters.name !== null && {
        name: parameters.name,
    })), (parameters.pod !== null && {
        pod: parameters.pod,
    })), (parameters.slack_channel_name !== undefined && {
        slack_channel_name: parameters.slack_channel_name,
    })), (parameters.identity_key !== undefined && {
        identity_key: parameters.identity_key,
    }));
};
const convertToCreationRequest = (parameters) => {
    return Object.assign(Object.assign({ name: parameters.name, short_name: parameters.short_name, pod: parameters.pod, client_type: parameters.client_type, properties: parameters.properties }, (parameters.slack_channel_name && {
        slack_channel_name: parameters.slack_channel_name,
    })), (parameters.identity_key && {
        identity_key: parameters.identity_key,
    }));
};
export const useClientStore = defineStore("clientStore", () => {
    const state = reactive({
        clients: {},
    });
    const setClients = (clientResponse) => {
        _.map(clientResponse, (response) => {
            const client = new Client(response);
            state.clients[client.client_id] = client;
            return client;
        });
    };
    const fetchClients = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield ClientEndpoints.getClients();
        setClients(data);
    });
    const fetchClient = (clientId) => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield ClientEndpoints.getClient(clientId);
        setClients([data]);
    });
    const getClients = () => {
        return _.values(state.clients);
    };
    const getClient = (clientId) => {
        return state.clients[clientId];
    };
    const createClient = (createRequest) => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield ClientEndpoints.createClient(convertToCreationRequest(createRequest));
        setClients([data]);
    });
    const updateClient = (clientId, updateRequest) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const request = convertToUpdateRequest(updateRequest);
        const tempTokenResponse = yield ClientAccessTokenEndpoints.createForClient({
            client_id: clientId,
            scopes: [Scope.CLIENT_SUPERUSER],
            durationSeconds: 60,
        });
        const tempAccessToken = (tempTokenResponse === null || tempTokenResponse === void 0 ? void 0 : tempTokenResponse.access_token) ||
            ((_a = tempTokenResponse === null || tempTokenResponse === void 0 ? void 0 : tempTokenResponse.data) === null || _a === void 0 ? void 0 : _a.access_token);
        const { data } = yield ClientEndpoints.editClientWithAuth(clientId, request, tempAccessToken);
        setClients([data]);
    });
    const deleteClient = (clientId) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const tempTokenResponse = yield ClientAccessTokenEndpoints.createForClient({
            client_id: clientId,
            scopes: [Scope.CLIENT_SUPERUSER],
            durationSeconds: 60,
        });
        const tempAccessToken = (tempTokenResponse === null || tempTokenResponse === void 0 ? void 0 : tempTokenResponse.access_token) ||
            ((_b = tempTokenResponse === null || tempTokenResponse === void 0 ? void 0 : tempTokenResponse.data) === null || _b === void 0 ? void 0 : _b.access_token);
        yield ClientEndpoints.deleteClientWithAuth(clientId, tempAccessToken);
        delete state.clients[clientId];
    });
    return {
        state,
        fetchClients,
        fetchClient,
        getClients,
        getClient,
        updateClient,
        createClient,
        deleteClient,
    };
});
